<template>
  <modal
    :showModal="showModal"
    @close-modal="$emit('close-modal')"
    title="View Request"
    width="30"
  >
    <section>
      <div class="py-3">
        <b>Fleet Details</b>
        <p class="py-2 pb-3">{{ this.requsetFleet.fleet.equipment }}, {{ this.requsetFleet.fleet.carriageCapacity }} Tonnes, {{ this.requsetFleet.fleet.vehicletype}}</p>
        <p>VIN: {{ this.requsetFleet.fleet.vehicleNumber }}</p>
      </div>
      <hr />

      <div class="py-3">
        <b>Requester</b>
        <p class="py-2 pb-3">Scelloo Logistics Limited</p>
        <p>{{ formatAddress(this.requsetFleet.user.address || "") }}</p>
      </div>
      <hr />

      <div class="py-3">
        <b>Contact Person</b>
        <p class="py-2 pb-3">{{ this.requsetFleet.user.firstname || ""}} {{ this.requsetFleet.user.lastname || "" }}</p>
        <p class="py-2 pb-3">{{ this.requsetFleet.user.email || "" }}</p>
        <p>{{ this.requsetFleet.user.mobile_no || "" }}</p>
      </div>
      <hr />

      <div class="py-3">
        <b>Selected Routes</b>
        <p class="py-2 pb-3">Lagos to Benin</p>
        <p class="py-2 pb-3">Benin to Lagos</p>
      </div>


      <div class="flex items-center justify-end mt-8">
          <button class="py-2 px-3 bg-primary-yellow" @click="approvalStatus = true">Approve</button>
          <button class="mx-3"  @click="approvalStatus = false">Disapprove</button>
      </div>
    </section>
  </modal>
</template>

<script>
export default {
  props: {
    showModal: Boolean,
    selectedFleet: Object,
  },
  data() {
    return {
      loading: false,
      requsetFleet: {},
      approvalStatus: undefined
    };
  },
  computed: {
     payload(){
      let loggedInUser = JSON.parse(localStorage.getItem("loggedInUser"))
      return {
          id:  this.requsetFleet.id,
          fleetId: this.requsetFleet.fleetId,
          orgId: loggedInUser.orgId,
          approvalStatus: this.approvalStatus ? 'approved' : 'disapproved',
          expiryDate: "2023-05-08",
          approvalBy: "964c2af0-c868-4860-861a-446ae4bac6f4",
          approvalDate: null
      }
     }
  },
  watch: {
    showModal(){
       this.getAllFleetRequest()
    },
    approvalStatus(){
       this.acceptFleetRequest()
    }
  },
  methods: {
    async acceptFleetRequest(){
      try {
        await this.$_acceptFleetRequest(this.payload)
      } catch (error) {
        this.handleError(error)
      }
    },
    async getAllFleetRequest(){
      try {
        let response = await this.$_getUserMyFleetRequest(this.selectedFleet.id)
        this.requsetFleet = response.data.data[0]
      } catch (error) {
        this.handleError(error)
      }
    },
    closeModal() {
      this.$emit("close-modal");
    },
  },
};
</script>

<style scoped>
.button-wrapper {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}
</style>
